import { Provider } from "react-redux";
import { RouterProvider } from "react-router/dom";
import { ToastContainer } from "react-toastify";
import Localization from "react-widgets/Localization";
import { DateLocalizer } from "react-widgets/IntlLocalizer";

import { store } from "./store";
import { router } from "./router/router";

const dateLocalizer = new DateLocalizer({ culture: "en-US" });

const App = () => (
    <Provider store={store}>
        <Localization date={dateLocalizer}>
            <RouterProvider router={router} />

            <ToastContainer containerId="A" position="bottom-center" theme="colored" icon={false} />
        </Localization>
    </Provider>
);

export default App;
